import adminLevelsTypes from './types';

const initialState = {
  levels: [],
  items: [],
  data: [],
  loadingItems: false,
  savingItems: false,
  loading: false,
  deletingAdminLevelItem: false,
  loadingLevels: false,
  savingLevels: false,
  errorOnLevels: null,
  error: false,
};

function adminLevelsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case adminLevelsTypes.FETCH_ADMIN_LEVELS_REQUEST:
      return {
        ...state,
        loadingLevels: true,
      };
    case adminLevelsTypes.FETCH_ADMIN_LEVELS_SUCCESS:
      return {
        ...state,
        loadingLevels: false,
        levels: payload.map((p, i) => ({ ...p, order: i })),
      };

    case adminLevelsTypes.FETCH_ADMIN_LEVELS_FAILURE:
      return {
        ...state,
        errorOnLevels: payload,
        loadingLevels: false,
        savingItems: false,
      };

    case adminLevelsTypes.ADD_NEW_ADMIN_LEVELS_REQUEST:
    case adminLevelsTypes.DELETE_ADMIN_LEVEL_REQUEST:
    case adminLevelsTypes.UPDATE_ADMIN_LEVEL_REQUEST:
      return {
        ...state,
        errorOnLevels: false,
        savingLevels: true,
      };

    case adminLevelsTypes.ADD_NEW_ADMIN_LEVELS_FAILURE:
    case adminLevelsTypes.DELETE_ADMIN_LEVEL_FAILURE:
    case adminLevelsTypes.UPDATE_ADMIN_LEVEL_FAILURE:
      return {
        ...state,
        errorOnLevels: payload,
        savingLevels: false,
      };

    case adminLevelsTypes.ADD_NEW_ADMIN_LEVELS_SUCCESS:
      return {
        ...state,
        levels: payload.map((p, i) => ({ ...p, order: i })),
        savingLevels: false,
        savingItems: false,
      };

    case adminLevelsTypes.DELETE_ADMIN_LEVEL_SUCCESS:
      return {
        ...state,
        levels: state.levels
          .filter((l) => l.id !== payload.id)
          .map((l) =>
            l.id === payload.parentId ? { ...l, childId: undefined } : l
          ),
        savingLevels: false,
      };

    case adminLevelsTypes.UPDATE_ADMIN_LEVEL_SUCCESS:
      return {
        ...state,
        levels: payload.map((p) => ({ ...p, adminLevel: p.name })),
        savingLevels: false,
      };

    case adminLevelsTypes.FETCH_ADMIN_LEVEL_ITEMS_REQUEST:
      return {
        ...state,
        error: false,
        loadingItems: true,
      };
    case adminLevelsTypes.UPDATE_ADMIN_LEVEL_ITEMS_DATA_REQUEST:
    case adminLevelsTypes.ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_REQUEST:
      return {
        ...state,
        error: false,
        savingItems: true,
      };
    case adminLevelsTypes.ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_SUCCESS:
      return {
        ...state,
        items: [...state.items, payload],
        loadingItems: false,
        savingItems: false,
        error: false,
      };

    case adminLevelsTypes.FETCH_ADMIN_LEVEL_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: payload,
        loadingItems: false,
        savingItems: false,
      };

    case adminLevelsTypes.DELETE_ADMIN_LEVEL_ITEMS_DATA_REQUEST:
      return {
        ...state,
        deletingAdminLevelItem: true,
      };

    case adminLevelsTypes.DELETE_ADMIN_LEVEL_ITEMS_DATA_SUCCESS:
      return {
        ...state,
        deletingAdminLevelItem: false,
        items: state.items.filter((item) => item.id !== payload.id),
      };

    case adminLevelsTypes.DELETE_ADMIN_LEVEL_ITEMS_DATA_FAILURE:
      return {
        ...state,
        deletingAdminLevelItem: false,
      };
    default:
      return state;
  }
}

export default adminLevelsReducer;
